import * as actionTypes from './actionsTypes';

export const setBookedShipmentId = (bookedshipmentId) => {
   
  return {
    type: actionTypes.SETBOOKEDSHIPMENTID,
    data: bookedshipmentId,
  };
};
